import React from "react";
import "./kycVerifyDetails.scss";
interface KycVerifyDetailsProps {
  kycLink?: string;
}

const KycVerifyDetails: React.FC<KycVerifyDetailsProps> = ({ kycLink }) => {
  return (
    <section className="kyc-section">
      <iframe title="kyc" src={kycLink} allow="camera" allowFullScreen></iframe>
    </section>
  );
};

export default KycVerifyDetails;
